import { Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    standalone: true,
    imports: [NgIf, MatProgressSpinnerModule]
})
export class LoadingSpinnerComponent {
    private _isShown: boolean = false;

    @Input() diameter: number = 20;

    get isShown(): boolean {
        return this._isShown;
    }

    show() {
        this._isShown = true;
    }

    hide() {
        this._isShown = false;
    }
}
